import { render, staticRenderFns } from "./EditorHome.vue?vue&type=template&id=38bf60d0&scoped=true&"
import script from "./EditorHome.vue?vue&type=script&lang=js&"
export * from "./EditorHome.vue?vue&type=script&lang=js&"
import style0 from "./EditorHome.vue?vue&type=style&index=0&id=38bf60d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf60d0",
  null
  
)

export default component.exports